import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Plx from 'react-plx';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import './index.css';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Roboto Slab',
    fontWeight: '200',
    fontSize: 'rem',
    color: '#c0c0c0',
    userSelect: 'none',
  },
}));

const ScrollForMore = ({ height = '50px', totalTransactionsSubmitted = 0, quarter, year }) => {
  const classes = useStyles();
  const [showScrollMessage, setShowScrollMessage] = React.useState(true);

  return (
    <>
      <div
        style={{
          height,
          width: '100%',
          position: 'absolute',
          bottom: '1rem',
          overflow: 'hidden',
          zIndex: 1000,
          paddingBottom: '1rem',
        }}
        data-testid="scroll-for-more"
      >
        <Plx
          data-testid="headline-panel"
          className={classes.headline}
          onPlxEnd={() => {
            setShowScrollMessage(false);
          }}
          parallaxData={[
            {
              start: 0,
              end: 700,
              easing: 'ease-in',
              properties: [
                {
                  startValue: 1,
                  endValue: 0,
                  property: 'opacity',
                },
              ],
            },
          ]}
          style={{
            position: 'absolute',
            width: '100%',
            height,
            zIndex: 100,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            opacity: 0,
          }}
        >
          <div className={classes.title}>
            {showScrollMessage ? (
              <span className="scroll-for-more">
                <ArrowDownwardIcon style={{ marginRight: '2rem', fontSize: '2rem' }} />
                Scroll for more
                <ArrowDownwardIcon style={{ marginLeft: '2rem', fontSize: '2rem' }} />
              </span>
            ) : null}
          </div>
        </Plx>
      </div>
    </>
  );
};

export default ScrollForMore;
